import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'title', label: 'Title', type: 'text' },
    { key: 'description', label: 'Description', type: 'textarea', rows: 2 },
    { key: 'category', label: 'Category', type: 'text' },
    { key: 'file_url', label: 'PDF file', type: 'upload-pdf', prefix: 'downloads' },
    { key: 'thumbnail_url', label: 'Thumbnail (optional)', type: 'upload-image', prefix: 'downloads/thumbs' },
    { key: 'file_size', label: 'File size (display)', type: 'text', placeholder: 'e.g. 1.7 MB' },
    { key: 'order', label: 'Order', type: 'number' },
];
const columns = [
    { key: 'title', label: 'Title', primary: true },
    { key: 'category', label: 'Category' },
    { key: 'file_size', label: 'Size' },
];
const defaultItem = {
    title: '',
    description: '',
    category: 'General',
    file_url: '',
    thumbnail_url: '',
    file_size: '',
    order: 99,
};

export default function AdminDownloadsPage() {
    return (
        <CrudManager
            resource="downloads"
            title="Downloads"
            description="Brochures, annual reports and compliance certificates. Upload PDFs directly — they are stored on Bunny CDN."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['title', 'category']}
        />
    );
}
